// create a react page that embeds a facebook page
//
import React, {useEffect, useState} from 'react';

import NavBar from "../components/NavBar";
import BottomBar from "../components/BottomBar";
import {useLocation} from "react-router-dom";
import BlogPosts from "../components/BlogPosts";
import {collection, getDocs, orderBy, query} from "@firebase/firestore";
import {db} from "../firebase";
import ProgramCardModal from "../components/Programs/ProgramCardModal";
import {ImageDir} from "../assets/imageDir";
import BlogPostModal from "../components/BlogPostModal";


function Announcements() {
    // firebase get all the posts insdie the collectino updatesc
   const [allPosts, setAllPosts] = useState([]);
   const [loading, setLoading] = useState(true);
   const [selectedPost, setSelectedPost] = useState(
       {
              'name': '',
              'header_image': '',
              'content': '',
              'created_on': ''
       }
   );
   const [modalShow, setModalShow] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState({ show: false, id: null, headerImage: null });
   const [deleting, setDeleting] = useState(false);

   const getPosts = async () => {
       const posts = []
       const q = query(collection(db, "updates"), orderBy("created_on", "desc"));

       const snapshot = await getDocs(q);
        snapshot.forEach((doc) => {
            if (doc.exists) {
                console.log(doc.id, " => ", doc.data());
                posts.push({ id: doc.id, ...doc.data() }); // include doc id
            }   else {
                console.log("No such document!");
            }
        });
        setAllPosts(posts); // move setAllPosts outside the loop
   }

   const handleDelete = async (id, headerImage) => {
     setConfirmDelete({ show: true, id, headerImage });
   };

   const confirmDeletePost = async () => {
     setDeleting(true);
     const { id, headerImage } = confirmDelete;
     try {
       await (await import('firebase/firestore')).deleteDoc(
         (await import('firebase/firestore')).doc(db, 'updates', id)
       );
       if (headerImage) {
         const { deleteObject, ref } = await import('firebase/storage');
         const { storage } = await import('../firebase');
         try {
           await deleteObject(ref(storage, headerImage));
         } catch (e) {
           // Ignore if image doesn't exist
         }
       }
       setAllPosts(posts => posts.filter(post => post.id !== id));
     } catch (err) {
       alert('Failed to delete post.');
     }
     setDeleting(false);
     setConfirmDelete({ show: false, id: null, headerImage: null });
   };

   const cancelDelete = () => {
     setConfirmDelete({ show: false, id: null, headerImage: null });
   };

    useEffect(() => {
          getPosts().then(r => console.log(r));

     }, []);
    const closeModal = () => {
        setSelectedPost(
            {
                'name': '',
                'header_image': '',
                'content': '',
                'created_on': ''
            }
        );
    };


    // use effect if selected post is not empty
//    get the post
    useEffect(() => {
        if (selectedPost['name'] !== '') {
        //     console post the post
            console.log(selectedPost.name);
        setModalShow(true)
        }
    }, [selectedPost]);
    return (
        <div className="bg-white min-h-screen p-8 md:pt-16 sm:pt-4 text-center">

            {/*create a grid for blog posts that is responsive*/}
            <div className={"text-black text-4xl font-extrabold mb-8"}>{'Announcements'}</div>

            <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"}>

                {allPosts.length === 0 && loading &&
                //     spinner
                <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
                </div>


                }

            {

                allPosts.map((post, index) => {
                    return <BlogPosts key={index}
                                      name={post['name']}
                                      headerImage={post['header_image']}
                                      content={post['content']}
                                      createdOn={post['created_on']}
                                      onClick={() => setSelectedPost({
                                            'name': post['name'],
                                            'header_image': post['header_image'],
                                            'content': post['content'],
                                            'created_on': post['created_on']
                                      })}
                                      onDelete={() => handleDelete(post.id, post['header_image'])}
                    />
                })

            }


                {selectedPost.name !== '' && (
                //     create blog post modal
                    <BlogPostModal
                        name={selectedPost.name}
                        headerImage={selectedPost.header_image}
                        content={selectedPost.content}
                        createdOn={selectedPost.created_on}
                        onClose={closeModal}/>


                )}

            </div>

            {/* Confirmation Dialog */}
            {confirmDelete.show && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white p-6 rounded shadow-lg text-center">
                  <h2 className="text-xl font-bold mb-4">Confirm Delete</h2>
                  <p className="mb-4">Are you sure you want to delete this post? This action cannot be undone.</p>
                  <div className="flex justify-center gap-4">
                    <button onClick={confirmDeletePost} className="bg-red-600 text-white px-4 py-2 rounded flex items-center justify-center min-w-[90px]" disabled={deleting}>
                      {deleting ? (
                        <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                        </svg>
                      ) : null}
                      {deleting ? 'Deleting...' : 'Delete'}
                    </button>
                    <button onClick={cancelDelete} className="bg-gray-300 px-4 py-2 rounded" disabled={deleting}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

        </div>
    );
}

export default Announcements;

